import React from "react";
import styled from "styled-components";
import { greyText } from "../../../styles";
import { CompassParagraph } from "../styledComponents";
import { Icon, IconContainer } from "../../visuals/styledComponents";

const SectionContainer = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }): number => gap ?? 8}px;
  width: 100%;
`;

const SectionHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

const SectionTitleText = styled(CompassParagraph)`
  font-size: 14px;
  color: ${greyText};
  margin: 0;
  letter-spacing: 0.5px;
`;

export interface ModalSectionProps {
  /** Section title */
  title?: string;
  /** Icon source for the section header */
  icon?: string;
  /** Gap between children (default: 8) */
  gap?: number;
  /** Content */
  children: React.ReactNode;
}

/**
 * A section container with optional header (icon + title)
 */
export const ModalSection: React.FC<ModalSectionProps> = ({
  title,
  icon,
  gap,
  children,
}) => {
  return (
    <SectionContainer gap={gap}>
      {(title || icon) && (
        <SectionHeaderContainer>
          {icon && (
            <IconContainer>
              <Icon src={icon} alt="" />
            </IconContainer>
          )}
          {title && <SectionTitleText>{title}</SectionTitleText>}
        </SectionHeaderContainer>
      )}
      {children}
    </SectionContainer>
  );
};

/**
 * Standalone section header for more control
 */
export const ModalSectionHeader: React.FC<{
  title: string;
  icon?: string;
}> = ({ title, icon }) => (
  <SectionHeaderContainer>
    {icon && (
      <IconContainer>
        <Icon src={icon} alt="" />
      </IconContainer>
    )}
    <SectionTitleText>{title}</SectionTitleText>
  </SectionHeaderContainer>
);

/**
 * Standalone section title text
 */
export const ModalSectionTitle = SectionTitleText;
